import { PARCEL_HIT_LAYERS } from './parcelAtPoint';

/** Layers used to read Land Records outlines (source id is still regrid-*). */
export const PARCEL_RENDER_LAYERS = PARCEL_HIT_LAYERS;

/** GeoFeature.type is max 10 chars and acreage only runs for `polygon`. */
export function areaDraftType(geometry) {
  const raw = String((geometry && geometry.type) || '').toLowerCase();
  if (raw === 'polygon' || raw === 'multipolygon') return 'polygon';
  return raw;
}

export function parcelFeatureId(props) {
  const p = props || {};
  const raw = p.lrid || p.parcelid || p.parcel_id || p.id || p.objectid || null;
  if (raw == null || String(raw).trim() === '') return null;
  return String(raw);
}

/**
 * All on-screen tile fragments for the selected lot ids.
 * Vector tiles clip at tile edges; the click geometry is often only one crumb.
 */
export function collectRenderedParcelGeometries(map, parcelIds) {
  const idSet = new Set(
    (Array.isArray(parcelIds) ? parcelIds : [])
      .map((id) => (id == null ? '' : String(id)))
      .filter(Boolean)
  );
  if (!map || typeof map.queryRenderedFeatures !== 'function' || idSet.size === 0) {
    return [];
  }
  const layers = PARCEL_RENDER_LAYERS.filter((id) => !map.getLayer || map.getLayer(id));
  if (!layers.length) return [];
  let feats = [];
  try {
    feats = map.queryRenderedFeatures({ layers }) || [];
  } catch (_) {
    return [];
  }
  const geometries = [];
  feats.forEach((feature) => {
    const id = parcelFeatureId(feature && feature.properties);
    if (!id || !idSet.has(id)) return;
    const geometry = feature && feature.geometry;
    if (!geometry || !geometry.type) return;
    if (geometry.type !== 'Polygon' && geometry.type !== 'MultiPolygon') return;
    geometries.push(geometry);
  });
  return geometries;
}

/** Prefer viewport fragments; fall back to the geometries stored on click. */
export function geometriesForUnion(selectedParcels, map) {
  const selected = Array.isArray(selectedParcels) ? selectedParcels : [];
  const ids = selected.map((p) => p && p.parcelId).filter((id) => id != null && String(id) !== '');
  const rendered = collectRenderedParcelGeometries(map, ids);
  if (rendered.length > 0) return rendered;
  return selected.map((p) => p && p.geometry).filter(Boolean);
}
